import { okamiRefreshGateway } from '@/lib/axios'

export async function refreshTokenCall(refreshToken?: string) {
  const { data } = await okamiRefreshGateway.post<{ token?: string }>('/auth/v2/refresh-token', {
    refreshToken,
  })

  return data.token
}
